import styled from "styled-components";
import Reveal from "../ui/Reveal";
import SectionLabel from "../ui/SectionLabel";
import { achievements, education } from "../../data/education";

function Education() {
  return (
    <Section id="education" aria-labelledby="education-heading">
      <SectionLabel>Education &amp; achievements</SectionLabel>
      <Grid>
        <Reveal as="div">
          <h2 id="education-heading">{education.degree}</h2>
          <h3>{education.institution}</h3>
          <Meta>
            <span>{education.location}</span>
            <span>{education.period}</span>
            <span>{education.detail}</span>
          </Meta>
        </Reveal>
        <Reveal as="div" delay={0.1}>
          <AchievementList>
            {achievements.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </AchievementList>
        </Reveal>
      </Grid>
    </Section>
  );
}

const Section = styled.section`
  max-width: 1240px;
  margin: auto;
  padding: 0 28px 110px;

  @media (max-width: 700px) {
    padding: 0 24px 70px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 60px;
  border-top: 1px solid var(--border);
  padding-top: 44px;

  h2 {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    letter-spacing: -0.02em;
    color: var(--text-primary);
    margin: 0 0 8px;
  }

  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-secondary);
    margin: 0;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 16px;
  font-size: 0.82rem;
  color: var(--text-muted);
  font-weight: 600;
`;

const AchievementList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;

  li {
    position: relative;
    padding-left: 22px;
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.6;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: var(--accent);
    }
  }
`;

export default Education;
